import React, { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';
import { Select } from 'antd';
import { withStore } from '../../../../store/BotAdminStore';
import CommonModal from '../../../Chat/common/CommonModal';
import { MyInput } from '../../../Base/Form';
import MessagePreview from '../../../Chat/PreparedMessages/TemplateMessages/components/AddOrEditTemplate/MessagePreview';
import ChannelSelect from '../../../Chat/ChatsList/ChannelSelect';
import { useStore } from '../../../../store/rootStore';
import ErrorComponent from '../../ErrorComponent';
import { ReactComponent as GreenPlus } from '../../../../assets/icons/plus/greenPlus.svg';
import styles from './CreateNewMiniBot.module.scss';
const { Option } = Select;
function CreateNewMiniBot({ onCancel, onConfirm, visible, store, initialChannel, initialTemplate }) {
    var _a, _b;
    const { t } = useTranslation();
    const { channels, templateMessagesStore } = useStore();
    const [namesUsed, setNamesUsed] = useState([]);
    const [identifier, setIdentifier] = useState('');
    const [selectedChannel, setSelectedChannel] = useState(initialChannel || null);
    const [selectedTemplate, setSelectedTemplate] = useState(initialTemplate || null);
    const [templatesList, setTemplatesList] = useState([]);
    const createMiniBot = () => {
        onConfirm(identifier, selectedChannel, selectedTemplate);
    };
    const resetForm = () => {
        setNamesUsed([]);
        store.clearErrors();
        setIdentifier('');
        setSelectedChannel(null);
        setSelectedTemplate(null);
        setTemplatesList([]);
    };
    const handleChannelChange = (channel) => {
        setSelectedChannel(channel);
        setSelectedTemplate(null);
        if (channel === null || channel === void 0 ? void 0 : channel.id) {
            const templates = templateMessagesStore.getOrLoadTemplateMessagesListByAccountId(channel.id);
            setTemplatesList(templates);
        }
        else {
            setTemplatesList([]);
        }
    };
    const handleTemplateChange = (templateId) => {
        const template = templatesList.find((t) => t._id === templateId);
        setSelectedTemplate(template || null);
    };
    useEffect(() => {
        if (visible) {
            setNamesUsed(Array.from(store.bots.keys()));
            if (initialChannel) {
                setSelectedChannel(initialChannel);
                const templates = templateMessagesStore.getOrLoadTemplateMessagesListByAccountId(initialChannel.id);
                setTemplatesList(templates);
            }
            if (initialTemplate) {
                setSelectedTemplate(initialTemplate);
            }
        }
        else {
            resetForm();
        }
    }, [visible, initialChannel, initialTemplate]);
    useEffect(() => {
        if (selectedChannel === null || selectedChannel === void 0 ? void 0 : selectedChannel.id) {
            const templates = templateMessagesStore.templateMessagesLists[selectedChannel.id];
            if (templates) {
                setTemplatesList(templates);
            }
        }
    }, [selectedChannel === null || selectedChannel === void 0 ? void 0 : selectedChannel.id, templateMessagesStore.templateMessagesLists]);
    return (React.createElement(CommonModal, { visible: visible, setModalVisible: onCancel, modalAction: createMiniBot, titleTextKey: 'createNewMiniBot', modalActionText: t('createMiniBot'), disabledButton: !identifier.trim().length || namesUsed.includes(identifier) || !selectedChannel, headerIcon: GreenPlus, width: 800, centerContent: false },
        React.createElement("div", { className: styles.content },
            React.createElement(ErrorComponent, { errors: store.flowVersionErrors, clearErrors: store.clearErrors, className: styles.errorWrapper }),
            React.createElement("div", { className: styles.formRow },
                React.createElement("div", { className: styles.label },
                    React.createElement(Trans, { i18nKey: "botName" })),
                React.createElement(MyInput, { value: identifier, onChangeHandler: (value) => setIdentifier(value), placeholder: t('exTexterBot'), size: "large" }),
                namesUsed.includes(identifier) && (React.createElement("div", { className: styles.inputError },
                    React.createElement(Trans, { i18nKey: "botIdentifierUsed", values: { identifier } })))),
            React.createElement("div", { className: styles.mainRow },
                React.createElement("div", { className: styles.leftColumn },
                    React.createElement("div", { className: styles.formRow },
                        React.createElement("div", { className: styles.label },
                            React.createElement(Trans, { i18nKey: "selectChannelLabel" })),
                        React.createElement(ChannelSelect, { activeChannel: selectedChannel, onChannelClick: handleChannelChange, accounts: channels.templateAccounts, showAll: false, size: "large", placeholder: t('chooseAChannel'), showBorders: true })),
                    React.createElement("div", { className: styles.formRow },
                        React.createElement("div", { className: styles.label },
                            React.createElement(Trans, { i18nKey: "selectTemplateLabel" }),
                            " ",
                            React.createElement("span", { className: styles.optionalLabel },
                                "(",
                                React.createElement(Trans, { i18nKey: "optional" }),
                                ")")),
                        React.createElement(Select, { value: selectedTemplate === null || selectedTemplate === void 0 ? void 0 : selectedTemplate._id, onChange: handleTemplateChange, placeholder: t('chooseATemplate'), size: "large", disabled: !selectedChannel, loading: templateMessagesStore.templateMessagesLoading }, templatesList.map((template) => (React.createElement(Option, { key: template._id, value: template._id }, template.title || template.name)))))),
                React.createElement("div", { className: styles.rightColumn }, selectedTemplate ? (React.createElement("div", null,
                    React.createElement(MessagePreview, { header: Object.assign(Object.assign({}, selectedTemplate.header), { type: (_a = selectedTemplate.header) === null || _a === void 0 ? void 0 : _a.type, text: ((_b = selectedTemplate.header) === null || _b === void 0 ? void 0 : _b.text) || '' }), body: {
                            text: selectedTemplate.text,
                        }, footer: selectedTemplate.footer, buttons: selectedTemplate.buttons, canCollapse: false, className: styles.previewContainer }))) : selectedChannel && templatesList.length === 0 && !templateMessagesStore.templateMessagesLoading ? (React.createElement("div", { className: styles.templatePreviewSection },
                    React.createElement("div", { className: styles.noPreview },
                        React.createElement(Trans, { i18nKey: "noTemplatesForChannel" }),
                        React.createElement("div", { className: styles.noPreviewHint },
                            React.createElement(Trans, { i18nKey: "youCanCreateMiniBotWithoutTemplate" }))))) : (React.createElement("div", { className: styles.templatePreviewSection },
                    React.createElement("div", { className: styles.noPreview },
                        React.createElement(Trans, { i18nKey: "selectTemplateToPreview" }),
                        React.createElement("div", { className: styles.noPreviewHint },
                            React.createElement(Trans, { i18nKey: "templateIsOptional" }))))))))));
}
export default withStore(observer(CreateNewMiniBot));
